import React, { useEffect, useState, useCallback } from 'react';
import { Trophy } from 'lucide-react';
import { useLang } from '../context/LanguageContext';
import { useEvent } from '../context/EventContext';
import { api } from '../lib/api';

export function AudienceResult() {
  const { t } = useLang();
  const { config } = useEvent();
  const eventId = config?.event?.id;
  const [data, setData] = useState(null);

  const load = useCallback(async () => {
    if (!eventId) return;
    try { setData(await api.voteResults(eventId)); } catch { /* ignore */ }
  }, [eventId]);

  useEffect(() => { load(); }, [load]);

  if (!config?.settings?.voting_enabled) return null;

  return (
    <div className="bg-gradient-to-b from-[#111A38] to-[#0B132B] border border-[#D4AF37]/30 rounded-2xl p-5" data-testid="audience-result">
      <h2 className="font-serif font-semibold text-xl text-[#E5C158] text-center">{t('audienceFavourite')}</h2>
      {!data?.revealed ? (
        <p className="text-sm text-slate-400 text-center mt-3">{t('resultLater')}</p>
      ) : (
        <div className="mt-4 space-y-3">
          {[...data.results].sort((a, b) => b.votes - a.votes).map((r, i) => (
            <div key={r.product_id} data-testid={`vote-bar-${r.order}`}>
              <div className="flex justify-between text-xs mb-1">
                <span className={`font-sans ${i === 0 ? 'text-[#E5C158] font-semibold' : 'text-slate-300'}`}>
                  {i === 0 && <Trophy size={12} className="inline mr-1" />}{r.name}
                </span>
                <span className="font-mono text-slate-400">{r.votes} · {r.percentage}%</span>
              </div>
              <div className="w-full bg-[#070C1E] h-2.5 rounded-full overflow-hidden border border-[#D4AF37]/15">
                <div className="grow-bar h-full rounded-full bg-gradient-to-r from-[#D4AF37] to-[#E5C158]" style={{ width: `${r.percentage}%` }} />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
